// Search params AKA query params
export const SEARCH_PARAM_KEYS = {
  statusCode: "code", // Status code to indicate error/alert, this is displayed in the UI in a toast
  nextUrl: "next", // Redirect to this URL after action (sign in, etc.)
  page: "page", // Pagination page
  search: "s", // Search string
};
